import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import OverlaySpinner from "../../../common/components/functional/overlaySpinner/OverlaySpinner";
import useFetchInitialData from "../../../hooks/useFetchInitialData";
import { DocumentTitle } from "../../../app/documentTitle/DocumentTitle";
import { HomeHeaderSpacer, HomeMenu } from "../../home/HomeMenu";
import { useProtectedRoute } from "../../login/useProtectedRoute";

export const ExamineInvoiceLayout = () => {
  const { user, isSessionLoading, loginRedirect } = useProtectedRoute();
  const { isLocalizationCompleted, localizationError } = useFetchInitialData();

  if (isSessionLoading) {
    return <OverlaySpinner isLoading />;
  }

  if (!user) {
    return loginRedirect;
  }

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <DocumentTitle />
      <HomeMenu user={user} fullWidth />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
        }}
      >
        <HomeHeaderSpacer />
        <OverlaySpinner isLoading={!isLocalizationCompleted} />
        {isLocalizationCompleted && !localizationError && <Outlet />}
      </Box>
    </Box>
  );
};
